/**
 * 侧栏 / 顶栏路由匹配：按路径段边界比较，并在多前缀命中时取最长路径。
 * 避免 `/customers` 误伤 `/customers-unknown`，也避免短前缀抢先于更具体菜单项。
 */
export function pathMatches(locationPath: string, itemPath: string): boolean {
  if (itemPath === '/') return locationPath === '/';
  return locationPath === itemPath || locationPath.startsWith(`${itemPath}/`);
}

export function matchNavItem<T extends { path: string }>(
  locationPath: string,
  items: readonly T[]
): T | undefined {
  if (locationPath === '/') {
    return items.find((item) => item.path === '/');
  }
  let best: T | undefined;
  for (const item of items) {
    if (item.path === '/' || !pathMatches(locationPath, item.path)) continue;
    if (!best || item.path.length > best.path.length) best = item;
  }
  return best;
}
